"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpecificPriceAttention = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const __1 = require("..");
const roundMoney_1 = require("../../../../utils/roundMoney");
const SpecificPriceAttention = (props) => {
    const { totalOnOpenCalculated, totalCalculated } = props;
    const { locale } = (0, react_intl_1.useIntl)();
    if (totalOnOpenCalculated === undefined)
        return null;
    if (totalCalculated === totalOnOpenCalculated)
        return null;
    return (react_1.default.createElement("div", { className: `${__1.className}__specific-price-attention` },
        react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/AdminPayment/SpecificPrice:Attention', defaultMessage: 'Warning: As a result of your changes, the calculated booking price has changed from {prevMoney} to {currentMoney}. Please make sure that the specific price is correct.', values: {
                prevMoney: `${(0, roundMoney_1.localizeMoney)(totalOnOpenCalculated, locale, 'Reservation/AdminPayment/components/SpecificPriceAttention/prevMoney')} CHF`,
                currentMoney: `${(0, roundMoney_1.localizeMoney)(totalCalculated, locale, 'Reservation/AdminPayment/components/SpecificPriceAttention/currentMoney')} CHF`,
            } })));
};
exports.SpecificPriceAttention = SpecificPriceAttention;
//# sourceMappingURL=SpecificPriceAttention.js.map